import generatedRoverTheme from '@rover/kibble/tokens/build/rover/es6/theme';

import { breakpoints } from './themeConstants';

const roverTheme = {
  ...generatedRoverTheme,
  breakpoints,
};

export default roverTheme;
